export default function getAltAxis(_0x5277f4){return _0x5277f4==='x'?'y':'x';}